<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
        <div class="d-flex justify-content-between">
              <div class="section-title">
                {{ "Remaning Item Per Concesion" }}
              </div>
              <div class="d-flex align-items-center">
               
                <div class="d-flex align-item-center">
                      <input value="1" type="radio" v-model="lang_id">
                      <span class="ml-1">English</span>
                    </div>
                    <div class="d-flex align-item-center ml-2">
                    <input value="2" type="radio" v-model="lang_id">
      
                    <span class="ml-1">العربية</span>
                  </div>
              </div>
            </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          
          <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div> -->

          <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div> -->

          <!-- Store Location Filter-->
           <!-- <div class="col-lg-6 col-xl-3 mb-4">
            <div class="dropdown-curve-container mr-2">
               <label :class="selectedLocation && selectedLocation.length > 0 ? 'shift-up' : 'font-weight-bold'">
                            {{ selectedLocation && selectedLocation.length > 0 ? $t("Store") : $t("All Store") }}
                            </label>

              <multiselect
                :disabled="isRoleID"
                :options="storeList"
                v-model="selectedLocation"
                :searchable="true"
                label="sm_store_name"
                track-by="sm_id"
                
                @input="onSelectLocation($event)"
                :showLabels="false"
                :multiple="true"
              ></multiselect>
            </div>
          </div> -->
          <!-- Store Location Filter-->

          <!-- Concession Item Filter -->
           <!-- Movie Filter -->
           <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                   <div class="dropdown-curve-container">
                     <label :class="selectedItemName && selectedItemName.length > 0 ? 'shift-up' : 'font-weight-bold'">
                       {{ selectedItemName && selectedItemName.length > 0 ? $t("Item") : $t("All Item") }}
                     </label>
                     <multiselect v-model="selectedItemName" :options="allItemNames" track-by="fst_item_name"
                       label="fst_item_name" :disabled="isRoleID" :searchable="true" placeholder="Item" :multiple="true">
                     </multiselect>
                   </div>
                 </div> -->
        <!-- Movie Filter -->
          <!-- Concession Item Filter -->

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="GetDetailedAdvanceSalesReport('N')"
            >
              {{ $t("fetch") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="remaningItemData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- s -->
        <a
          target="_blank"
          @click="GetDetailedAdvanceSalesReport('Y','N')"
          title="Download as PDF"
          download
          style="cursor: pointer;"
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/pdf.svg"
            height="25"
            width="25"
          />
        </a>

            <a
          target="_blank"
          @click="GetDetailedAdvanceSalesReport('N','Y')"
          title="Download as PDF"
          download
          style="cursor: pointer;"
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </a>
      </div>

      <div>
        <div class="table-scroll">
          <table
             :class="lang_id==2?'swc-report-table reverse-order ':'swc-report-table order '"   
                        border="1"
            v-if="remaningItemData.length > 0"
          >
            <thead class="bg-lightgrey">
              <tr :class="lang_id == 2 ? ' text-right':'text-center'">              
                <th >{{ trans("item",lang_id) }}</th>
                <th>{{ trans("stock",lang_id) }}</th>
                <th>{{ trans("cost",lang_id) }}</th>
                <th>{{ trans("totalCost",lang_id) }}</th>
              </tr>

            </thead>
            <tbody
              v-for="(itemData, DataIndex) in remaningItemData"            
            >
                <tr >         
                  <td class="text-left">
                   {{itemData.rm_name}}
                  </td>
                    <td class="text-right">
                    {{currFormat(itemData.system_stock)}}
                  </td>
                   <td class="text-right">
                    {{currFormat(itemData.single_rate)}}
                </td>
                  <td class="text-left">
                    {{ currFormat(  itemData.system_stock * itemData.single_rate) }}
                  </td>
                </tr>
            </tbody> 

            <thead class="bg-lightgrey">
              <tr>
              <th colspan="3" :class="lang_id == 1 ? 'text-left' : 'text-right'">Total</th>
              <th class="text-left">
                                {{
                      currFormat(
                        remaningItemData.reduce((acc, { system_stock, single_rate }) => {
                          return acc + system_stock * single_rate;
                        }, 0)
                      )
                    }}
                </th>
              </tr>
            </thead> 

          </table>
        </div>
      </div>

      <table
        v-if="remaningItemData.length === 0"
        class="swc-report-table swc_table_header"
        border="1"
      >
         <thead class="bg-lightgrey">
              <tr>
                <th rowspan="">Total Cost</th>
                <th colspan="2">Cost</th>
                <th colspan="2">Stock</th>
                <th colspan="1">Item</th>
              </tr>
            </thead>
        <tbody>
          <tr>
            <td colspan="14">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
  
  <script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";
import PosFnbService from "@/services/PosFnbService";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
        selectedItemName: [],
        allItemNames: [],
        storeList: [],
        selectedLocation: [ ],
       lang_id:"1",
      isRoleID: false,
      submitted: false,
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      remaningItemData: [],
      grandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  watch: {
      fromDate() {
        this.GetDetailedAdvanceSalesReport("N", "N", "filter");
      },
      toDate() {
        this.GetDetailedAdvanceSalesReport("N", "N", "filter");
      },
  },
  mounted() {},
  methods: {
     getStockManagementData: function(cinema_id) {
            let payload = {
              cinema_id: cinema_id,
            };
            PosFnbService.GetStoreManagementDetails(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.Records && data.Records.length) {
                  this.storeList = [...response.data.Records];
                  // this.selectedLocation=this.storeList[0];
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          },
           onSelectLocation: function(event) {
                  console.log("evenet=>", event);
                  this.selectedLocation = event || [  ];
                },
    onChangeDate(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.getStockManagementData(event.cine_id);
      this.$store.dispatch("selectDropdownCinema", event);
    },
    GetDetailedAdvanceSalesReport(isPdf = "N",isExcel = "N", type = "") {
      this.remaningItemData = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        lang_id: this.lang_id,
        store_id: this.selectedLocation.map(x =>x.sm_id),
        store_name: this.selectedLocation.map(x =>x.sm_store_name),
        isPdf,
        isExcel
      };
       if (type === "filter") {
            payload["type"] = "filter";
          }
      
          if (this.selectedItemName.length) {
            payload["selectedItemName"] = this.selectedItemName.map(item => item.fst_item_name);
          }

      ReportsService.getRemaningItemPerConcession(payload)
        .then((response) => {
          const { data } = response;
        
          if (!data.status) { return this.$toasted.show(data.message); }
             if (type == "filter") {
                  this.allItemNames = [...data.itemNamesData];
                }
                else{
            this.remaningItemData = [...data.Records];
            console.log("remaningItemData",this.remaningItemData)
            this.grandTotal = data.grandTotal;

            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
             if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            this.$toasted.show(data.message);
            }
         
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>
  
  <style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.reverse-order{
  direction: rtl;
}
.order{
  direction: ltr
}
</style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/remaningItemPerConcession.vue